import { isIndiaCountry } from './region';

type CountryReadyInput = {
  userCountry?: string | null;
  detectedCountry?: string | null;
  detectionSettled: boolean;
  isIOSAppEnvironment: boolean;
};

export const normalizeCountryCode = (country?: string | null): string | null => {
  const code = (country || '').trim().toUpperCase();

  return /^[A-Z]{2}$/.test(code) ? code : null;
};

export const resolveBillingCountry = (
  userCountry?: string | null,
  detectedCountry?: string | null,
): string | null => normalizeCountryCode(userCountry) || normalizeCountryCode(detectedCountry);

export const isCountryReadyForPricing = ({
  userCountry,
  detectedCountry,
  detectionSettled,
  isIOSAppEnvironment,
}: CountryReadyInput): boolean => (
  isIOSAppEnvironment
  || Boolean(resolveBillingCountry(userCountry, detectedCountry))
  || detectionSettled
);

export const getDefaultPricingCurrency = (
  billingCountry?: string | null,
  isIOSAppEnvironment = false,
): 'USD' | 'INR' => (
  isIndiaCountry(billingCountry) && !isIOSAppEnvironment ? 'INR' : 'USD'
);

/**
 * The currency prices are shown and charged in: the one chosen on the profile
 * page, else the country's (India is INR). The iOS app always sells in USD.
 */
export const resolvePricingCurrency = (
  preferredCurrency: string | null | undefined,
  billingCountry?: string | null,
  isIOSAppEnvironment = false,
): 'USD' | 'INR' => {
  if (isIOSAppEnvironment) return 'USD';
  if (preferredCurrency === 'USD' || preferredCurrency === 'INR') return preferredCurrency;

  return getDefaultPricingCurrency(billingCountry);
};
